import axios from '@fs/zion-axios'
import { Strophe } from 'react-strophe'
import { Chat } from '../../global/chatSettingsConfig'
import { getBookmarkDetailsByBulk } from './bookmarks'
import { sanitizeChatRoomTitle } from '../../global/sanitize-chat-room'

const serviceBaseUrl = '/service/rootstech/rtc2021/orchestration'

export const getChatRoom = ({ jid }) => {
  return axios.get(`${serviceBaseUrl}/chat/groups/${jid}`)
}

export const createChatRoom = ({ friendlyName, description, groupType, parentJid }) => {
  const validTitle = sanitizeChatRoomTitle(friendlyName)
  return axios.post(`${serviceBaseUrl}/chat/groups`, {
    title: validTitle,
    description: description?.trim(),
    groupType,
    parentJid,
  })
}

export const searchForChatRoomByExactName = ({ searchStr, type }) => {
  const query = encodeURIComponent(searchStr.trim())
  return axios.get(`${serviceBaseUrl}/chat/groups?title=${query}&groupType=${type}`)
}

export const searchForChatRoom = async ({ searchStr, type, limit = 50 }) => {
  const query = encodeURIComponent(searchStr.trim())
  const response = await axios.get(
    `${serviceBaseUrl}/chat/groups/search?title=${query}&description=${query}&groupType=${type}&limit=${limit}`
  )
  const chatRoomData = response?.data?.results || []

  // Fetch the description and guestCount for these
  const jids = chatRoomData.map((room) => `${room.jid}@${Chat.Settings.MUC_DOMAIN}`)
  const details = await getBookmarkDetailsByBulk({ jids })
  const detailsData = details?.data?.bookmarks || {}

  // Merge the data together
  const newData = chatRoomData.map((room) => {
    const jidToMatch = room.jid.includes(Chat.Settings.MUC_DOMAIN)
      ? room.jid
      : `${room.jid}@${Chat.Settings.MUC_DOMAIN}`
    const matchingDetails = detailsData[jidToMatch]
    // Update structure so we can re-use this object in ChatRoomSearchResults.
    return {
      jid: room.jid.includes(Chat.Settings.MUC_DOMAIN) ? room.jid : `${room.jid}@${Chat.Settings.MUC_DOMAIN}`,
      name: room.title,
      title: room.title,
      guestCount: matchingDetails?.guestCount,
      description: matchingDetails?.description,
      isParent: room.parent,
    }
  })

  return newData
}

export const getChildrenChatRooms = async ({ parentJid }) => {
  const node = parentJid.includes(Chat.Settings.MUC_DOMAIN)
    ? Strophe.getNodeFromJid(parentJid).toUpperCase()
    : parentJid
  const response = await axios.get(`${serviceBaseUrl}/chat/groups/${node}/children`)
  const chatRoomData = response?.data?.results || []

  // Fetch the description and guestCount for these
  const jids = chatRoomData.map((room) => `${room.jid}@${Chat.Settings.MUC_DOMAIN}`)
  const details = await getBookmarkDetailsByBulk({ jids })
  const detailsData = details?.data?.bookmarks || {}

  // Merge the data together
  const newData = chatRoomData.map((room) => {
    const jidToMatch = room.jid.includes(Chat.Settings.MUC_DOMAIN)
      ? room.jid
      : `${room.jid}@${Chat.Settings.MUC_DOMAIN}`
    const matchingDetails = detailsData[jidToMatch]

    return {
      jid: room.jid.includes(Chat.Settings.MUC_DOMAIN) ? room.jid : `${room.jid}@${Chat.Settings.MUC_DOMAIN}`,
      name: room.title,
      title: room.title,
      guestCount: matchingDetails?.guestCount,
      description: matchingDetails?.description,
    }
  })

  return newData
}
